import React, { useEffect, useState } from "react";
import { Modal, Form, Input, Select, Alert, Table, message } from "antd";
import companyService from "../../../services/company.service";

const { Option } = Select;

const TableItems = ({ rows }: { rows: any[] }) => {
  // Sumar los precios
  const totalPrice = rows.reduce((sum, row) => sum + Number(row.price), 0);

  const columns: any = [
    {
      title: "#",
      dataIndex: "certificate_number",
      key: "certificate_number",
      sorter: false,
    },
    {
      title: "Placa",
      dataIndex: "plate",
      key: "plate",
      sorter: false,
    },
    {
      title: "Precio",
      dataIndex: "price",
      key: "price",
      sorter: false,
      align: "right",
    },
  ];

  return (
    <Table
      pagination={false}
      style={{ marginTop: 10 }}
      size="small"
      columns={columns}
      dataSource={rows}
      footer={() => (
        <div style={{ textAlign: "right" }}>
          <strong>Total: </strong>PEN {Number(totalPrice).toFixed(2)}
        </div>
      )}
    />
  );
};
export interface BillingModalProps {
  rows: any[];
  open: boolean;
  onOk: (data: any) => void;
  onCancel: () => void;
  confirmLoading?: boolean;
  descriptionDefault?: string;
}

const BillingModal: React.FC<BillingModalProps> = ({
  open,
  onOk,
  onCancel,
  confirmLoading,
  descriptionDefault = "",
  rows,
}) => {
  const [isDuplicate, setIsDuplicate] = useState(false);

  useEffect(() => {
    const companyIds = rows.map((row) => row.company_id);

    const uniqueCompanyIds = new Set(companyIds);
    if (uniqueCompanyIds.size > 1) {
      setIsDuplicate(true);
    } else {
      setIsDuplicate(false);
    }
  }, [rows]);

  const [form] = Form.useForm();

  const fetchCompany = async () => {
    const { data } = await companyService.find(rows[0]?.company_id);
    form.setFieldsValue({
      customer_name: data.fullname,
      document_number: data.document_number,
      document_type: data.document_type,
    });
  };

  const [type, setType] = useState<string>("summary");

  useEffect(() => {
    if (rows.length == 0) {
      return;
    }
    fetchCompany();
  }, [rows]);

  const onSend = () => {
    onOk(form.getFieldsValue());
  };

  return (
    <Modal
      title="Generar factura única"
      open={open}
      onOk={onSend}
      onCancel={onCancel}
      okText="Confirmar"
      cancelText="Cancelar"
      confirmLoading={confirmLoading}
      okButtonProps={{ disabled: isDuplicate }}
    >
      {isDuplicate && (
        <Alert
          type="error"
          style={{marginBottom: 10}}
          message="Para factura unica debes seleccionar solamente una empresa"
        />
      )}
      <Form
        form={form}
        layout="horizontal"
        labelCol={{ span: 8 }}
        wrapperCol={{ span: 16 }}
        initialValues={{ description: descriptionDefault }}
      >
        <Form.Item
          name="type"
          label="Tipo"
          initialValue="summary"
          rules={[{ required: true, message: "Selecciona un tipo" }]}
        >
          <Select onChange={setType}>
            <Option value="summary">Resumido</Option>
            <Option value="detailed">Detallado</Option>
          </Select>
        </Form.Item>

        <Form.Item
          name="document_number"
          label="RUC/DNI"
          rules={[{ required: true, message: "RUC" }]}
        >
          <Input
            readOnly
            placeholder="RUC"
            style={{ background: "whitesmoke" }}
          />
        </Form.Item>

        <Form.Item
          name="customer_name"
          label="Empresa"
          rules={[{ required: true, message: "Ingresa la empresa" }]}
        >
          <Input
            readOnly
            placeholder="Nombre"
            style={{ background: "whitesmoke" }}
          />
        </Form.Item>
        <Form.Item
          hidden
          name="document_type"
          label="document_type"
          rules={[{ required: true }]}
        >
          <Input type="hidden" />
        </Form.Item>

        <Form.Item
          name="payment_condition"
          label="Condición de pago"
          initialValue={'cash'}
          rules={[{ required: true, message: "Ingresa la condición de pago" }]}
        >
          <Select>
            <Option value="cash">Al contado</Option>
            <Option value="credit">Al crédito</Option>
          </Select>
        </Form.Item>

        <Form.Item
          name="payment_method"
          label="Método de pago"
           initialValue={'cash'}
          rules={[{ required: true, message: "Ingresa el método de pago" }]}
        >
          <Select>
            <Option value="cash">Efectivo</Option>
            <Option value="yape">Yape</Option>
            <Option value="bank-transfer">
              Transferencia Bancaria
            </Option>
            <Option value="credit-card">
              Izipay
            </Option>
          </Select>
        </Form.Item>

        <Form.Item
          name="purchase_order"
          label="Orden de compra"
          rules={[{ required: false, message: "Ingresa OC" }]}
        >
          <Input />
        </Form.Item>
        <Form.Item
          name="voucher"
          label="N° Operación"
          rules={[{ required: false, message: "Ingresa OC" }]}
        >
          <Input />
        </Form.Item>

        {type === "summary" && (
          <Form.Item
            name="description"
            label="Descripción del ítem"
            rules={[
              { required: true, message: "Por favor ingresa una descripción" },
            ]}
          >
            <Input.TextArea
              rows={2}
              placeholder="Ingresa la descripción de la factura"
            />
          </Form.Item>
        )}

        <Form.Item
          name="notes"
          label="Notas"
          rules={[{ required: false, message: "Notas" }]}
        >
          <Input.TextArea />
        </Form.Item>

        {type == "single" && (
          <Alert
            type="info"
            message={`Se mostrará ${rows.length} items en la factura `}
          ></Alert>
        )}

        <TableItems rows={rows} />
      </Form>
    </Modal>
  );
};

export default BillingModal;
